import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 80px auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }
`;

export const Heading = styled.h2`
  font-size: 1.375rem;
  line-height: 130%;
  color: ${({ headingColor }) =>
    headingColor
      ? themeGet(`colors.${headingColor}`)
      : themeGet('colors.main-text')};
  margin-bottom: 0.25rem;
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.25rem;
    line-height: 130%;
  }
`;

export const Subheading = styled.p`
  font-size: 1.125rem;
  line-height: 1.875rem;
`;

export const ContentWrapper = styled.div`
  .swiper {
    overflow-x: hidden;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 2rem;
    padding-top: 0.75rem;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NavigationButton = styled.div`
  color: ${themeGet('colors.esso-red')};
  padding: 0.75rem 2.25rem;
  border-radius: 3.125rem;
  border: 2px solid ${themeGet('colors.esso-red')};
  cursor: pointer;
  width: 150px;
  text-align: center;
`;

export const NavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 1.5rem;
`;
